import React from 'react';
import { Outlet, useState, useEffect, useLocation } from "../../imports/generalImport";
import { Box, Container } from "../../imports/muiImport";
import MobileFooterNavigation from '../mobileComponents/footerNavigation/MobileFooterNavigation';
import MobileHeaderDrawer from '../mobileComponents/headerNavigation/MobileHeaderDrawer';
import ScrollToTop from '../../components/other/ScrollToTop';
import { Helmet } from 'react-helmet-async';
const constantUserNames = ['/login', '/signup', '/password-reset'];

function MobileDesignLayout({ children }) {
  const [isPageTitleUpdate, setIsPageTitleUpdate] = useState(false);
  const [pageTitle, setPageTitle] = useState('');
  const location = useLocation();
  const canonicalUrl = `https://www.99gift.in${location.pathname}${location?.search && location?.search}`;

  useEffect(() => {
    if (constantUserNames.includes(location?.pathname) !== false) {
      updatePageTitle(location?.pathname);
    } else {
      setIsPageTitleUpdate(false);
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <meta property="og:url" content={canonicalUrl} />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      <Container
        maxWidth="false"
        disableGutters
        sx={{
          display: 'flex',
          flexDirection: 'column',
          overflowX: "hidden",
          position: "relative",
          backgroundColor: '#fff',
        }}
      >
        <ScrollToTop />

        <Box
          sx={{
            height: 64,
          }}
        >
          <MobileHeaderDrawer isPageTitleUpdate={isPageTitleUpdate} pageTitle={pageTitle} />
        </Box>

        <Box sx={{ height: 15 }} />
        <Box
          component={"div"}
          sx={{
            flex: 1,
            mb: 10
          }}
        >
          <Outlet>
            {children}
          </Outlet>
        </Box>


        {!isPageTitleUpdate &&
          (
            <Box sx={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 9,
              // backgroundColor: 'white.main',
              display: 'flex',
              justifyContent: 'center',
              width: '100%',

              backgroundColor: 'transparent',
            }}>
              <MobileFooterNavigation />
            </Box>
          )
        }
      </Container>
    </>
  );


  function updatePageTitle(pageTitle) {
    const pages = pageTitle.split('/').pop();
    const modified = pages.split('-').join(' ');
    const titleName = modified.charAt(0).toUpperCase() + modified.slice(1);
    setPageTitle(titleName);
    setIsPageTitleUpdate(true);
  }

}

export default MobileDesignLayout;